import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useToken from '../../hooks/useToken';  
import { Form, Button, Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import './Login.css';  // New CSS file for styling
import { redirectToProgressStep } from '../../hooks/progressNavigator'; // New utility function for navigation
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { token, saveToken } = useToken();
  const navigate = useNavigate();

  // Helper function to check role access
  const isAuthorizedRole = (role) => {
    return role === "PLAYER";
  };

  const isAdminRole = (role) => {
    return role === "ADMIN";
  }

  // Redirect to account page if user is already logged in
  useEffect(() => {
    if (token) {
      const role = localStorage.getItem('role');
      if (role && isAdminRole(role)) {
        navigate("/admin", { replace: true });
        window.location.reload();
        return;
      }
      if (role && isAuthorizedRole(role)) {
        navigate(`/dashboard`, { replace: true });
      } else {
        setError('Unauthorized access');
        logout();
      }
    }
  });

  const logout = () => {
    localStorage.clear(); // Clear session data
    saveToken(null, null); // Remove tokens
    navigate('/', { replace: true }); // Redirect to login page
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');  // Clear any existing error messages

    try {
      const response = await fetch("/api"+'/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
        credentials: 'include' // Send cookies (refresh token)
      });

      const data = await response.json();

      if (response.ok) {
        if (!isAuthorizedRole(data.role) && !isAdminRole(data.role)) {
          setError('Unauthorized access');
          logout();
          return;
        }

        // Store session data
        saveToken(data.access_token, data.refresh_token); // Save both tokens
        localStorage.setItem('fullName', data.full_name);  // Store full_name
        localStorage.setItem('role', data.role);  // Store role
        localStorage.setItem('address', data.address);  // Store address

        if (isAdminRole(data.role)) {
          navigate("/admin", { replace: true });
          window.location.reload();
          return;
        }

        // ✅ Fetch the current step right after login
        const progressRes = await fetch("/api"+'/player/progress', {
          headers: {
            Authorization: `Bearer ${data.access_token}`,
          },
        });

        if (progressRes.ok) {
          const progressData = await progressRes.json();
          console.log("Progress step on login:", progressData.progress_step);
          
          // ✅ This is the right way (not useProgressRedirect)
        redirectToProgressStep(progressData.progress_step, navigate);
        } else {
          console.error("Failed to fetch progress, navigating to dashboard");
          navigate('/dashboard', { replace: true }); // Fallback
        }
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred during login.');
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <div className="login-container">
              <h2 className="mb-1">Login</h2>
              <p className="subtitle">Experiment Participant</p>

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleLogin} className="login-form">
                <Form.Group className="form-group" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input"
                    placeholder="Enter your email"
                    required
                  />
                </Form.Group>

                <Form.Group className="form-group" controlId="formPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input"
                    placeholder="Enter your password"
                    required
                  />
                </Form.Group>

                <Button type="submit" className="login-btn">
                  Login
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
